import PropTypes from "prop-types";

import DirectoryTable from "@/directory/DirectoryTable";
import JoinClass from "@/student/JoinClass";
import useUser from "@/users/useUser";
import getHighestRoleLevel from "../getHighestRoleLevel";
import {
  FILTER_UI_PROPS,
  getColumns,
} from "./UserClassroomDirectoryTable.constants";
import { containerCss } from "./UserClassroomDirectoryTable.style";

const UserClassroomDirectoryTable = (props) => {
  const {
    TableNotFound,
    showSearch,
    classrooms,
    isLoading,
    count,
    controls,
    fetchClassrooms,
    pageSize,
  } = props;
  const { data: user } = useUser();
  const primaryRole = getHighestRoleLevel(user.roles);
  const columns = getColumns(primaryRole);

  const notFoundMessage = (
    <DirectoryTable.NotFound subTitle="There are no classes associated with your account" />
  );

  return (
    <div css={containerCss}>
      <DirectoryTable
        data={classrooms}
        pageSize={pageSize}
        columns={columns}
        initialState={controls}
        totalCount={count}
        loading={isLoading}
        notFoundMessage={TableNotFound || notFoundMessage}
        onControlsUpdateCb={fetchClassrooms}
        filterUIProps={showSearch ? FILTER_UI_PROPS : undefined}
        filterDefinitions={{}}
      />
      {user.roles.includes("student") && (
        <JoinClass onJoinedClass={() => fetchClassrooms()} />
      )}
    </div>
  );
};

UserClassroomDirectoryTable.propTypes = {
  /**
   * Custom not found message
   */
  TableNotFound: PropTypes.node,
  /**
   * Show search input field
   */
  showSearch: PropTypes.bool,
  /**
   * Classes data to populate the table
   */
  classrooms: PropTypes.arrayOf(PropTypes.object).isRequired,
  /**
   * Is loading classes data
   */
  isLoading: PropTypes.bool,
  /**
   * Total results of the query
   */
  count: PropTypes.number,
  /**
   * Table initial controls
   */
  controls: PropTypes.object,
  /**
   * Callback function when table is changed
   */
  fetchClassrooms: PropTypes.func.isRequired,
  /**
   * Rows per page
   */
  pageSize: PropTypes.number.isRequired,
};

UserClassroomDirectoryTable.defaultProps = {
  showSearch: false,
  classrooms: [],
  count: 0,
};

export default UserClassroomDirectoryTable;
